import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../../config/appConfig';

export default function DetalleNegocio({ negocioId, onBack, onEdit, onAuthError }) {
    const [negocio, setNegocio] = useState(null);
    const [loading, setLoading] = useState(true);
    const [nuevoEstado, setNuevoEstado] = useState('');
    const [nuevaFecha, setNuevaFecha] = useState('');
    const [cambiandoEstado, setCambiandoEstado] = useState(false);
    const [cambiandoFecha, setCambiandoFecha] = useState(false);
    const [generandoToken, setGenerandoToken] = useState(false);
    const [tokenCopiado, setTokenCopiado] = useState(false);

    const token = localStorage.getItem('superadmin_token');
    const authHeaders = { headers: { 'token': token, 'Content-Type': 'application/json' } };

    useEffect(() => {
        cargarDetalle();
    }, [negocioId]);

    const cargarDetalle = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${config.api_url}/api/bimba/negocios/${negocioId}`, authHeaders);
            if (res.data && res.data.status === "success") {
                const data = res.data.data;
                setNegocio(data);
                setNuevoEstado(data.estado_licencia);
                // 🚩 Asegurar que la fecha se muestre correctamente en el input type="date"
                //    Si viene como "2026-05-15" o "2026-05-15 00:00:00", extraer solo YYYY-MM-DD
                let fecha = data.fecha_corte_pago || '';
                if (fecha && fecha.includes(' ')) {
                    fecha = fecha.split(' ')[0]; // Tomar solo la parte de la fecha
                }
                console.log("📅 Fecha corte cargada:", fecha);
                setNuevaFecha(fecha);
            } else {
                toast.error("Error al cargar detalle");
            }
        } catch (err) {
            console.error(err);
            if (err.response && err.response.status === 401) {
                onAuthError();
                return;
            }
            toast.error(!err.response ? "No se pudo conectar con el servidor." : "Error de conexión");
        } finally {
            setLoading(false);
        }
    };

    const handleCambiarEstado = async () => {
        if (!nuevoEstado) return;
        setCambiandoEstado(true);
        try {
            const res = await axios.put(
                `${config.api_url}/api/bimba/negocios/${negocioId}/estado`,
                { estado: nuevoEstado },
                authHeaders
            );
            if (res.data && res.data.status === "success") {
                toast.success(`Estado cambiado a ${nuevoEstado}`);
                cargarDetalle();
            } else {
                toast.error(res.data.message || "Error al cambiar estado");
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                onAuthError();
                return;
            }
            toast.error(!err.response ? "No se pudo conectar con el servidor." : "Error al cambiar estado");
        } finally {
            setCambiandoEstado(false);
        }
    };

    const handleCambiarFecha = async () => {
        if (!nuevaFecha) {
            toast.warning("Selecciona una fecha");
            return;
        }
        setCambiandoFecha(true);
        try {
            const res = await axios.put(
                `${config.api_url}/api/bimba/negocios/${negocioId}/fecha-inicio-servicio`,
                { fecha_inicio: nuevaFecha },
                authHeaders
            );
            if (res.data && res.data.status === "success") {
                toast.success("Fecha de inicio actualizada");
                cargarDetalle();
            } else {
                toast.error(res.data.message || "Error al actualizar fecha");
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                onAuthError();
                return;
            }
            toast.error(!err.response ? "No se pudo conectar con el servidor." : "Error al actualizar fecha");
        } finally {
            setCambiandoFecha(false);
        }
    };

    const handleGenerarToken = async () => {
        if (!window.confirm('¿Estás seguro de generar un NUEVO token de impresión?\n\n⚠️ El token anterior dejará de funcionar inmediatamente.\nEl cliente de impresión deberá ser actualizado con el nuevo token.')) {
            return;
        }
        setGenerandoToken(true);
        try {
            const res = await axios.post(
                `${config.api_url}/api/bimba/negocios/${negocioId}/generar-token`,
                {},
                authHeaders
            );
            if (res.data && res.data.status === "success") {
                toast.success("✅ Token de impresión generado correctamente");
                cargarDetalle();
            } else {
                toast.error(res.data.message || "Error al generar token");
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                onAuthError();
                return;
            }
            toast.error(!err.response ? "No se pudo conectar con el servidor." : "Error al generar token");
        } finally {
            setGenerandoToken(false);
        }
    };

    const handleCopiarToken = () => {
        if (negocio && negocio.token_impresion) {
            navigator.clipboard.writeText(negocio.token_impresion).then(() => {
                setTokenCopiado(true);
                toast.success("✅ Token copiado al portapapeles");
                setTimeout(() => setTokenCopiado(false), 3000);
            }).catch(() => {
                toast.error("Error al copiar. Selecciona manualmente.");
            });
        }
    };

    const getEstadoStyle = (estado) => {
        switch (estado) {
            case 'AL_DIA': return { bg: '#e6faf5', color: '#10b981', label: 'Al Día', icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z' };
            case 'PENDIENTE': return { bg: '#fff8e6', color: '#f59e0b', label: 'Pendiente', icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z' };
            case 'BLOQUEADA': return { bg: '#ffe6e6', color: '#ef4444', label: 'Bloqueada', icon: 'M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z' };
            default: return { bg: '#f3f4f6', color: '#6b7280', label: estado, icon: 'M12 9v2m0 4h.01' };
        }
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        width: '32px', height: '32px',
                        border: '3px solid #e5e7eb', borderTopColor: '#667eea',
                        borderRadius: '50%', animation: 'spin 0.6s linear infinite',
                        margin: '0 auto 12px'
                    }}/>
                    <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>Cargando detalle del negocio...</p>
                </div>
            </div>
        );
    }

    if (!negocio) {
        return (
            <div style={{
                margin: '24px', padding: '20px',
                background: '#fef2f2', border: '1px solid #fecaca',
                borderRadius: '12px', color: '#dc2626',
                display: 'flex', alignItems: 'center', gap: '12px'
            }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                <span style={{ flex: 1 }}>No se encontró el negocio</span>
                <button onClick={onBack} style={{
                    padding: '8px 16px', background: '#dc2626', color: '#fff',
                    border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px'
                }}>Volver</button>
            </div>
        );
    }

    const es = getEstadoStyle(negocio.estado_licencia);

    const planInfo = {
        MENU_QR: { label: 'Pedidos Web', bg: '#f3effc', color: '#7c3aed' },
        POS: { label: 'POS Take Away', bg: '#f3effc', color: '#7c3aed' },
        RESTAURANTE: { label: 'Plan Restaurante', bg: '#f3effc', color: '#7c3aed' },
    };
    const plan = planInfo[negocio.plan] || planInfo.RESTAURANTE;

    const InfoRow = ({ label, value }) => (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 0',
            borderBottom: '1px solid #f3f4f6'
        }}>
            <span style={{ color: '#6b7280', fontSize: '13px', fontWeight: 500 }}>{label}</span>
            <span style={{ color: '#1a1a2e', fontSize: '14px', fontWeight: 600 }}>{value}</span>
        </div>
    );

    const ModuleBadge = ({ active, label, icon }) => (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '12px 16px',
            background: active ? '#f0fdf4' : '#f9fafb',
            borderRadius: '10px',
            border: `1.5px solid ${active ? '#bbf7d0' : '#e5e7eb'}`
        }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={active ? '#10b981' : '#9ca3af'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d={icon}/>
            </svg>
            <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', fontWeight: 600, color: '#1a1a2e' }}>{label}</div>
                <div style={{ fontSize: '11px', color: active ? '#10b981' : '#9ca3af', fontWeight: 500 }}>
                    {active ? 'Habilitado' : 'Deshabilitado'}
                </div>
            </div>
            <div style={{
                width: '8px', height: '8px',
                borderRadius: '50%',
                background: active ? '#10b981' : '#d1d5db'
            }}/>
        </div>
    );

    const icons = {
        web: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z',
        pedidos: 'M3 3h18v18H3V3zm2 2v14h14V5H5zm2 2h10v2H7V7zm0 4h10v2H7v-2zm0 4h7v2H7v-2z',
        kds: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z',
        qr: 'M3 3h7v7H3V3zm2 2v3h3V5H5zm-2 13h7v7H3v-7zm2 2v3h3v-3H5zM21 3h7v7h-7V3zm2 2v3h3V5h-3zm-2 13h7v7h-7v-7zm2 2v3h3v-3h-3z',
        pedidosQr: 'M3 3h7v7H3V3zm11 0h7v7h-7V3zM3 14h7v7H3v-7zm13 0h5v5h-5v-5z',
        propina: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z',
        telefono: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z',
        sii: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0 1 12 2.944a11.955 11.955 0 0 1-8.618 3.04A12.02 12.02 0 0 0 3 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
    };

    return (
        <div style={{
            padding: '32px',
            maxWidth: '1200px',
            margin: '0 auto',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
            {/* HEADER */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '28px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <button onClick={onBack} style={{
                        padding: '10px',
                        background: '#fff',
                        border: '1.5px solid #e5e7eb',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        display: 'flex'
                    }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
                        </svg>
                    </button>
                    <div>
                        <h1 style={{
                            fontSize: '24px',
                            fontWeight: '700',
                            color: '#1a1a2e',
                            margin: '0 0 4px',
                            letterSpacing: '-0.5px'
                        }}>{negocio.nombre}</h1>
                        <p style={{ color: '#6b7280', fontSize: '13px', margin: 0 }}>ID: #{negocio.id}</p>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '8px 16px',
                        background: plan.bg,
                        color: plan.color,
                        borderRadius: '10px',
                        fontSize: '13px',
                        fontWeight: 600
                    }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                        </svg>
                        Plan: {plan.label}
                    </span>
                    <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '8px 16px',
                        background: es.bg,
                        color: es.color,
                        borderRadius: '10px',
                        fontSize: '13px',
                        fontWeight: 600
                    }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d={es.icon}/>
                        </svg>
                        {es.label}
                    </span>
                    <button onClick={() => onEdit(negocio.id)} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        padding: '10px 20px',
                        background: '#1a1a2e',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '13px',
                        fontWeight: 600,
                        cursor: 'pointer'
                    }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                        </svg>
                        Editar
                    </button>
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: '24px' }}>
                {/* COLUMNA IZQUIERDA */}
                <div>
                    {/* INFORMACIÓN */}
                    <div style={{
                        background: '#fff',
                        borderRadius: '16px',
                        border: '1px solid #f3f4f6',
                        padding: '24px',
                        marginBottom: '20px'
                    }}>
                        <h3 style={{
                            fontSize: '15px',
                            fontWeight: '600',
                            color: '#1a1a2e',
                            margin: '0 0 16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
                            </svg>
                            Información del Negocio
                        </h3>
                        <InfoRow label="Nombre" value={negocio.nombre}/>
                        <InfoRow label="ID" value={`#${negocio.id}`}/>
                        <InfoRow label="Plan Comercial" value={
                            <span style={{
                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                padding: '4px 10px', background: plan.bg, color: plan.color,
                                borderRadius: '6px', fontSize: '12px', fontWeight: 600
                            }}>
                                {plan.label}
                            </span>
                        }/>
                        <InfoRow label="Estado" value={
                            <span style={{
                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                padding: '4px 10px', background: es.bg, color: es.color,
                                borderRadius: '6px', fontSize: '12px', fontWeight: 600
                            }}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d={es.icon}/></svg>
                                {es.label}
                            </span>
                        }/>
                        <InfoRow label="Fecha de alta" value={negocio.fecha_alta || 'Sin registro'}/>
                        <InfoRow label="Inicio período actual" value={negocio.fecha_inicio_periodo || 'Sin registro'}/>
                        <InfoRow label="Vence" value={negocio.fecha_corte_pago || 'Sin asignar'}/>
                        <InfoRow label="Bloqueo (si no paga)" value={negocio.fecha_bloqueo_calculada || 'Por calcular'}/>
                        <InfoRow label="Staff" value={`${negocio.total_staff} operador(es)`}/>
                        <InfoRow label="POS" value={negocio.cantidad_pos}/>
                    </div>

                    {/* MÓDULOS */}
                    <div style={{
                        background: '#fff',
                        borderRadius: '16px',
                        border: '1px solid #f3f4f6',
                        padding: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '15px',
                            fontWeight: '600',
                            color: '#1a1a2e',
                            margin: '0 0 16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
                            </svg>
                            Módulos Habilitados
                        </h3>
                        <p style={{ color: '#9ca3af', fontSize: '12px', margin: '-8px 0 16px' }}>
                            Menú QR va incluido gratis en cualquier plan. Pedidos Web viene incluido en el plan Pedidos Web; en POS/RESTAURANTE es el add-on que se activa desde Editar. Pedidos por Carta QR es otro add-on: los pedidos desde la mesa funcionan igual sin él.
                        </p>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                            <ModuleBadge active={negocio.plan === 'MENU_QR' || negocio.usa_web} label="Pedidos Web" icon={icons.web}/>
                            <ModuleBadge active={negocio.usa_pedidos_qr} label="Pedidos por Carta QR" icon={icons.pedidosQr}/>
                            <ModuleBadge active={negocio.usa_pedidos_mesa} label="Pedidos en Mesa" icon={icons.mesas || icons.pedidosQr}/>
                            <ModuleBadge active={negocio.envia_boletas_sii} label="Boletas SII" icon={icons.sii}/>
                        </div>
                    </div>
                </div>

                {/* COLUMNA DERECHA */}
                <div>
                    {/* ESTADO */}
                    <div style={{
                        background: '#fff',
                        borderRadius: '16px',
                        border: '1px solid #f3f4f6',
                        padding: '24px',
                        marginBottom: '20px'
                    }}>
                        <h3 style={{
                            fontSize: '15px',
                            fontWeight: '600',
                            color: '#1a1a2e',
                            margin: '0 0 16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                                <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                            </svg>
                            Estado de Servicio
                        </h3>
                        <div style={{ marginBottom: '14px' }}>
                            <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151', marginBottom: '6px' }}>Cambiar Estado</label>
                            <select value={nuevoEstado} onChange={(e) => setNuevoEstado(e.target.value)}
                                style={{
                                    width: '100%', padding: '12px 14px',
                                    border: '1.5px solid #e5e7eb', borderRadius: '10px',
                                    fontSize: '14px', outline: 'none', background: '#fff',
                                    color: '#374151', boxSizing: 'border-box'
                                }}>
                                <option value="AL_DIA">Al Día</option>
                                <option value="PENDIENTE">Pendiente</option>
                                <option value="BLOQUEADA">Bloqueada</option>
                            </select>
                        </div>
                        <button onClick={handleCambiarEstado}
                            disabled={cambiandoEstado || nuevoEstado === negocio.estado_licencia}
                            style={{
                                width: '100%', padding: '12px',
                                background: cambiandoEstado ? '#9ca3af' : '#f59e0b',
                                color: '#fff', border: 'none', borderRadius: '10px',
                                fontSize: '13px', fontWeight: 600, cursor: cambiandoEstado ? 'not-allowed' : 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
                            }}>
                            {cambiandoEstado ? (
                                <div style={{ width: '16px', height: '16px', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }}/>
                            ) : (
                                <>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
                                    Aplicar Cambio
                                </>
                            )}
                        </button>
                        <div style={{
                            marginTop: '12px', padding: '10px 14px',
                            background: negocio.estado_licencia === 'BLOQUEADA' ? '#fef2f2' :
                                        negocio.estado_licencia === 'PENDIENTE' ? '#fffbeb' : '#f0fdf4',
                            borderRadius: '8px',
                            color: negocio.estado_licencia === 'BLOQUEADA' ? '#dc2626' :
                                   negocio.estado_licencia === 'PENDIENTE' ? '#d97706' : '#10b981',
                            fontSize: '12px', fontWeight: 500
                        }}>
                            {negocio.estado_licencia === 'BLOQUEADA'
                                ? 'Este negocio está bloqueado. Los usuarios no podrán acceder al sistema.'
                                : negocio.estado_licencia === 'PENDIENTE'
                                ? 'Este negocio está en estado pendiente. Próximo a vencer.'
                                : 'El negocio está al día. Todo funcionando correctamente.'}
                        </div>
                    </div>

                    {/* INICIO DEL SERVICIO */}
                    <div style={{
                        background: '#fff',
                        borderRadius: '16px',
                        border: '1px solid #f3f4f6',
                        padding: '24px',
                        marginBottom: '20px'
                    }}>
                        <h3 style={{
                            fontSize: '15px',
                            fontWeight: '600',
                            color: '#1a1a2e',
                            margin: '0 0 16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
                            </svg>
                            Inicio del Servicio
                        </h3>
                        <p style={{ fontSize: '12px', color: '#6b7280', margin: '0 0 14px', lineHeight: '1.5' }}>
                            El día del mes en que el negocio comenzó a operar. 
                            Cada mes se renueva automáticamente en esta fecha.
                            Si no se paga, hay <strong>4 días de gracia</strong> antes del bloqueo.
                        </p>
                        <div style={{ marginBottom: '14px' }}>
                            <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151', marginBottom: '6px' }}>Día de Inicio (fecha)</label>
                            <input type="date" value={nuevaFecha} onChange={(e) => setNuevaFecha(e.target.value)}
                                style={{
                                    width: '100%', padding: '12px 14px',
                                    border: '1.5px solid #e5e7eb', borderRadius: '10px',
                                    fontSize: '14px', outline: 'none', boxSizing: 'border-box'
                                }}/>
                            {negocio.fecha_corte_pago && (
                                <small style={{ color: '#9ca3af', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                                    Inicio registrado: <strong>{negocio.fecha_corte_pago}</strong>
                                </small>
                            )}
                        </div>
                        <button onClick={handleCambiarFecha} disabled={cambiandoFecha}
                            style={{
                                width: '100%', padding: '12px',
                                background: cambiandoFecha ? '#9ca3af' : '#1a1a2e',
                                color: '#fff', border: 'none', borderRadius: '10px',
                                fontSize: '13px', fontWeight: 600, cursor: cambiandoFecha ? 'not-allowed' : 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
                            }}>
                            {cambiandoFecha ? (
                                <div style={{ width: '16px', height: '16px', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }}/>
                            ) : (
                                <>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
                                    Guardar Fecha de Inicio
                                </>
                            )}
                        </button>
                    </div>

                    {/* TOKEN DE IMPRESIÓN */}
                    <div style={{
                        background: '#fff',
                        borderRadius: '16px',
                        border: '1px solid #f3f4f6',
                        borderLeft: '4px solid #667eea',
                        padding: '24px'
                    }}>
                        <h3 style={{
                            fontSize: '15px',
                            fontWeight: '600',
                            color: '#1a1a2e',
                            margin: '0 0 16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#667eea" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/>
                            </svg>
                            Token de Impresión
                        </h3>
                        {negocio.token_impresion ? (
                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#374151', marginBottom: '6px' }}>Token Actual</label>
                                <div style={{ display: 'flex', gap: '6px' }}>
                                    <input type="text" readOnly value={negocio.token_impresion}
                                        style={{
                                            flex: 1, padding: '10px 14px',
                                            border: '1.5px solid #e5e7eb', borderRadius: '10px',
                                            fontSize: '12px', fontFamily: 'monospace',
                                            background: '#f9fafb', outline: 'none',
                                            letterSpacing: '0.5px', color: '#374151'
                                        }}/>
                                    <button onClick={handleCopiarToken}
                                        style={{
                                            padding: '10px 14px',
                                            background: tokenCopiado ? '#10b981' : '#fff',
                                            border: `1.5px solid ${tokenCopiado ? '#10b981' : '#e5e7eb'}`,
                                            borderRadius: '10px', cursor: 'pointer',
                                            color: tokenCopiado ? '#fff' : '#6b7280'
                                        }}>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            {tokenCopiado
                                                ? <polyline points="20 6 9 17 4 12"/>
                                                : <><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></>
                                            }
                                        </svg>
                                    </button>
                                </div>
                                <small style={{ color: '#9ca3af', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                                    Configurar en config_print.json del cliente
                                </small>
                            </div>
                        ) : (
                            <div style={{
                                padding: '12px 16px', background: '#fffbeb',
                                borderRadius: '10px', color: '#d97706',
                                fontSize: '12px', fontWeight: 500, marginBottom: '14px'
                            }}>
                                Este negocio no tiene token de impresión asignado.
                            </div>
                        )}
                        <button onClick={handleGenerarToken} disabled={generandoToken}
                            style={{
                                width: '100%', padding: '12px',
                                background: generandoToken ? '#9ca3af' : '#667eea',
                                color: '#fff', border: 'none', borderRadius: '10px',
                                fontSize: '13px', fontWeight: 600, cursor: generandoToken ? 'not-allowed' : 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
                            }}>
                            {generandoToken ? (
                                <div style={{ width: '16px', height: '16px', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }}/>
                            ) : (
                                <>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
                                    {negocio.token_impresion ? 'Regenerar Token' : 'Generar Token'}
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
                input:focus, select:focus {
                    border-color: #667eea !important;
                    box-shadow: 0 0 0 3px rgba(102,126,234,0.1);
                }
            `}</style>
        </div>
    );
}
